<section class="card">
  <div class="flex justify-between">
    <h2>Editar Plan</h2>
    <app-back-button ></app-back-button>
  </div>
  <form (ngSubmit)="saveSubscription()" class="p-4 max-w-m w-md space-y-4">

    <div class="grid grid-cols-12">
      <div class="pb-4 pr-4 col-span-4">
        <label for="shopSubscriptionName" class="block mb-1 font-semibold">Nombre del Plan</label>
        <input id="shopSubscriptionName" type="text" pInputText [(ngModel)]="subscription.shopSubscriptionName" name="shopSubscriptionName" required class="w-full" />
      </div>
      
      <div class="pb-4 pr-4 col-start-6 col-span-2">
        <label for="shopMaxUsers" class="block mb-1 font-semibold">Máximo Usuarios</label>
        <input id="shopMaxUsers" type="number" pInputText [(ngModel)]="subscription.shopMaxUsers" name="shopMaxUsers" min="0" step="1" required class="w-sm" />
      </div>
      
      <div class="pb-4 pr-4 col-start-10 col-span-2">
        <label for="shopMaxProducts" class="block mb-1 font-semibold">Máximo Productos</label>
        <input id="shopMaxProducts" type="number" pInputText [(ngModel)]="subscription.shopMaxProducts" name="shopMaxProducts" min="0" step="1" required class="w-sm" />
      </div>
    </div>
    <div class="grid grid-cols-12">
      <div class="pb-4 col-span-3 pb-4">
        <label class="flex flex-wrap items-center space-x-2">
          <p-toggleSwitch [(ngModel)]="subscription.shopPosAccess" name="shopPosAccess" onLabel="Sí" offLabel="No"></p-toggleSwitch>
          <span>Acceso POS</span>
        </label>
      </div>
      <div class="pb-4 col-span-3 pb-4">
        <label class="flex flex-wrap items-center space-x-2">
          <p-toggleSwitch [(ngModel)]="subscription.shopAnaliticsAccess" name="shopAnaliticsAccess" onLabel="Sí" offLabel="No"></p-toggleSwitch>
          <span>Acceso Analíticas</span>
        </label>
      </div>
      <div class="pb-4 col-span-3 pb-4">
        <label class="flex flex-wrap items-center space-x-2">
          <p-toggleSwitch [(ngModel)]="subscription.shopInfobipIntegrationAllow" name="shopInfobipIntegrationAllow" onLabel="Sí" offLabel="No"></p-toggleSwitch>
          <span>Chat App</span>
        </label>
      </div>
      <div class="pb-4 col-span-3 pb-4">
        <label class="flex flex-wrap items-center space-x-2">
          <p-toggleSwitch [(ngModel)]="subscription.shopValidateClientAccess" name="shopValidateClientAccess" onLabel="Sí" offLabel="No"></p-toggleSwitch>
          <span>Validación de clientes</span>
        </label>
      </div>
      <div class="pb-4 col-span-3 pb-4">
        <label class="flex flex-wrap items-center space-x-2">
          <p-toggleSwitch [(ngModel)]="subscription.shopCalendarAccess" name="shopCalendarAccess" onLabel="Sí" offLabel="No"></p-toggleSwitch>
          <span>Agenda Timekit</span>
        </label>
      </div>
      <div class="pb-4 col-span-3 pb-4">
        <label class="flex flex-wrap items-center space-x-2">
          <p-toggleSwitch [(ngModel)]="subscription.shopCashRegisterAccess" name="shopCashRegisterAccess" onLabel="Sí" offLabel="No"></p-toggleSwitch>
          <span>Cajas</span>
        </label>
      </div>
    </div>
    <hr>

    <div class="grid grid-cols-12">
      <div class="pb-4 col-span-3">
        <label class="block mb-1 font-semibold pb-4">Tipos de Producto Permitidos</label>
        <div *ngFor="let option of productTypeOptions" class="flex items-center space-x-2 pb-4">
          <p-checkbox [(ngModel)]="selectedProductTypes" (ngModelChange)="onProductTypesChange()" [value]="option.value" name="shopProductTypesAllow" inputId="{{option.value}}" size="large"></p-checkbox>
          <label [for]="option.value">{{ option.label }}</label>
        </div>
      </div>
      
      <div class="pb-4 col-span-3">
        <label class="block mb-1 font-semibold pb-4">Planes</label>
        <div *ngFor="let planOption of planOptions" class="flex items-center space-x-2 pb-4">
          <p-checkbox 
            [inputId]="planOption.name"
            [binary]="true"
            [(ngModel)]="planOption.checked"
            (onChange)="onPlanChange($event, planOption)"
            [ngModelOptions]="{standalone: true}"
            size="large">
          </p-checkbox>
          <label [for]="planOption.name">{{ planOption.label }}</label>
        </div>
      </div>

      <div class="pb-4 col-span-3">
        <label class="block mb-1 font-semibold pb-4">Imports / Exports</label>
        <div *ngFor="let ieOption of importExportOptions" class="flex items-center space-x-2 pb-4">
          <p-checkbox 
            [inputId]="ieOption.name" 
            [binary]="true"
            [(ngModel)]="ieOption.checked"
            (onChange)="onIECheckboxChange($event, ieOption)"
            [ngModelOptions]="{standalone: true}"
            size="large">
          </p-checkbox>
          <label [for]="ieOption.name">{{ ieOption.label }}</label>
        </div>
      </div>
      
      <div class="pb-4 col-span-3">
        <label class="block mb-1 font-semibold pb-4">Logs</label>
        <div *ngFor="let logOption of logOptions" class="flex items-center space-x-2 pb-4">
          <p-checkbox 
            [inputId]="logOption.name" 
            [binary]="true"
            [(ngModel)]="logOption.checked"
            (onChange)="onLogsChange($event, logOption)"
            [ngModelOptions]="{standalone: true}"
            size="large">
          </p-checkbox>
          <label [for]="logOption.name">{{ logOption.label }}</label>
        </div>  
      </div>
    </div>
    <div class="flex justify-center">
      <p-button severity="success" [loading]="loading" variant="outlined" rounded (click)="saveSubscription()">
        Guardar Cambios
      </p-button>
    </div>
  </form>
  <p-toast></p-toast>
</section>